import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {withRouter, Link} from 'react-router-dom';
import { Card, Image, Label, Button, Icon, Header, Dimmer } from 'semantic-ui-react';

import Utils from 'utils/Utils.js';
import UserUtils from 'utils/UserUtils.js';
import Portal from 'modules/misc/Portal.js';

import wellnessMonster from 'img/wellness-monster.png';
import Daily from './customCards/Daily.js';
import Ring from 'modules/misc/Ring.js';
import CardsContainer from 'modules/cards/CardsContainer.js';
import LogCardContainer from 'modules/logs/LogCardContainer.js';
import CarouselContainer from './CarouselContainer.js';
import Challenges from './Challenges.js';
import Competitions from './Competitions.js';
import UserChallenges from './UserChallenges.js';
import LoadInline from 'modules/loading/LoadInline.js';
import {colors, fontSizes, fonts, spacings, layout, shadow} from 'style';

import './today.css';

var style={
    container: {
        position:'relative',
        ...fonts.body,
        lineHeight: '1.5'
    },
    content: {
        maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        minHeight: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        boxSizing:'border-box', 
        paddingTop:'30px',
        backgroundColor: 'white',
    },
    avatarLabelContainer: {
        width: '100%', 
        height:'32px'
    },
    avatarLabel: {
        textAlign: 'right',
        color: '#fff',
        backgroundColor: colors.themeBlue,
        fontWeight: 'normal',
        position: 'relative',
        width: '100px',
        paddingRight: '20px',
        borderRadius: '100px',
    },
    pointsLabel: {
        backgroundColor: colors.pointsYellow,
    },
    starIcon: {
        position: 'absolute',
        left: '6px',
        top: '6px',
        fontSize: '1.5em',
        opacity: '1',
        color: '#FFF'
    },
    resourceIcon: {
        position: 'absolute',
        left: '6px',
        top: '6px',
        fontSize: '1.3em',
        opacity: '1',
        color: '#FFF'
    },
    avatarCard: {
        padding: '10px 15px 10px 15px',
        overflow: 'hidden',
        width: '300px'
    },
    name: {
        color: colors.themeBlue,
        textAlign: 'center',
        overflow: 'visible',
    },
    userMeta: {
        paddingBottom: '10px',
        color: colors.themeBlue,
        textAlign: 'center',
        fontSize: '1.2em',
    },
    avatarContainer: {
        position: 'relative',
        display: 'inline-block',
        height: '120px',
        width: '120px',
    },
    avatar: {
        marginLeft: '15px',
        marginTop: '15px',
        width: '90px',
        height: '90px',
        borderRadius: '50%',
    },
    ring:{
        position: 'absolute',
        top: '0px',
        left: '0px',
    },
    profileInfo: {
        float: 'right',
        display: 'inline-block',
    },


    flexBR: {
        width: '100%',
        height: '0',
    },
    divider: {
        backgroundColor: colors.themeBlue,
        position: 'relative',
        color: '#fff',
        width: '100%',
        textAlign: 'center',
        //borderRadius: '6px',
    },
    dividerText: {
        lineHeight: 'normal',
        padding: '10px 0px 0px 0px',
    },
    dividerSubText: {
        lineHeight: 'normal',
        padding: '0px 0px 10px 0px',
        fontSize: '0.9em'
    },
    dividerIcon: {
        position: 'absolute',
        backgroundColor: 'rgba(0,0,0,0)',
        color: '#fff',
        left: '10px',
        top: '50%',
        marginTop: '-20px',
    },
    customCards: {
        display: 'flex',
        justifyContent:'center',
        flexWrap: 'wrap',
    },
    twoColumns: {
        width:'100%', 
        textAlign: 'center', 
        verticalAlign:'top'
    },
    column: {
        display: 'inline-block',
        maxWidth:'450px', 
        verticalAlign:'top'
    },
    singleColumn: {
        maxWidth: '450px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    dimmerChallengeIcon: {
        fontSize: '50px',
        color: colors.themeBlue,
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '50%',
        margin: '10px',
        lineHeight: '3',
    },
    dimmerChallengeDescription:{
        color: '#fff',
        ...fonts.body,
        lineHeight: '1.5'
    },
    setGoals: {
        ...fonts.body,
        lineHeight: '1.5',
        backgroundColor: colors.themeBlue,
        color: '#fff',
        width: '100%',
        textAlign: 'center',
        marginTop: spacings.large,
        paddingTop: spacings.large,
        paddingBottom: spacings.large,
        paddingRight: spacings.large,
        paddingLeft: spacings.large,
        position: 'fixed',
        left: '0px',
        bottom: '0px',
        zIndex: '90',
    },
    setGoalsSpacer: {
        height: '200px',
    },
    setGoalsButton: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        boxShadow: shadow,
        backgroundColor: '#fff',
        color: colors.themeBlue,
        borderRadius: '100px',
        padding: '.78571429em 1.5em .78571429em',
    },
    setGoalsMessage: {
        position: 'relative',
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '320px',
    },
    goalsMonsterAvatar: {
        position: 'absolute',
        right: '-60px',
        top: '10px',
        display: 'inline-block', 
        width: '60px',
        height: '60px',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: '#fff',
        borderRadius: '50%', 
        backgroundPosition: '-10px 0px',
        backgroundSize: '76px 76px',
        backgroundRepeat: 'no-repeat',
    },
    cardsContainerWrapper: {
        paddingBottom: spacings.base,
    }
};


const Today = ({t,
                busy, 
                cards,
                challenges, 
                pinned, 
                timelineHistory,
                userProfile,
                userRank,
                logCategories,
                selectedLogCategory,
                dimmerChallenge,
                showSetGoals,
                onSkipLeft,
                onSkipRight,
                onClickHistory,
                onLaunchChallenge, 
                onLaunchCompetition, 
                onLaunchCompetitionActivities, 
                onNavigate,
                onLaunchUserChallenge, 
                editSubscriptions,
                formatDuration, 
                challengeTypeToName,
                getChallengeImageUrl,
                getCompetitionYellowLabel,
                onAddNewGoal}) => (
    <div className="full-height" style={{...style.container, ...(Boolean(dimmerChallenge) ? {overflow:'hidden'} : {})}}>
        {busy && 
            <div style={style.content}>
                <LoadInline centered /> 
            </div>
        }
        {!busy &&
            <div style={style.content}>


                <CarouselContainer />

                <div style={style.customCards}>
                    {pinned.map((pinnedItem,i) => (
                            <Daily key={i} 
                                   pinnedItem={pinnedItem}
                                   onNavigate={onNavigate} />
                    ))}
                </div>

                
                <LogCardContainer userProfile={userProfile} categories={logCategories} selectedCategory={selectedLogCategory} />

                <div style={style.cardsContainerWrapper} className='cardsContainerWrapper'>
                    <CardsContainer cards={cards} />
                </div>

                <Competitions competitions={cards.filter(c => c.type==='competition')} 
                            onLaunchCompetition={onLaunchCompetition}
                            onLaunchCompetitionActivities={onLaunchCompetitionActivities}
                            formatDuration={formatDuration}
                            typeToName={challengeTypeToName}
                            getChallengeImageUrl={getChallengeImageUrl}
                            getCompetitionYellowLabel={getCompetitionYellowLabel} />

                {showSetGoals ? (
                    <Portal>
                        <div style={style.setGoals}>
                            <div style={style.setGoalsMessage}>
                                <div style={{...style.goalsMonsterAvatar, backgroundImage:Utils.url(wellnessMonster)}}></div>
                                {Utils.endlToBr(t('set_goals_message'))} 
                            </div>
                            <br />
                            <Link to='/setgoals' style={style.setGoalsButton}>
                                {t('Set Goals')}
                            </Link>
                        </div>  
                    </Portal>
                ) : (
                    <div>
                        <div style={style.divider}>
                            <Button icon style={style.dividerIcon} onClick={editSubscriptions}><Icon className="icon-settings2" size="large"/></Button>
                            <div style={style.dividerText}>{t('Daily Goals')}</div>
                            <div style={style.dividerSubText}>
                                {t('{{challenges}} to go', {challenges:challenges.length})}
                            </div>
                        </div>
                        <Challenges challenges={challenges} 
                                    onSkipLeft={onSkipLeft}
                                    onSkipRight={onSkipRight}
                                    onClickHistory={onClickHistory}
                                    onLaunchChallenge={onLaunchChallenge}
                                    formatDuration={formatDuration}
                                    typeToName={challengeTypeToName}
                                    getChallengeImageUrl={getChallengeImageUrl} 
                                    onAddNewGoal={onAddNewGoal} />


                        <div style={style.divider}>
                            <div style={style.dividerText}>
                                {t('{{completed}} Completed', {completed:timelineHistory.length})}
                            </div>
                            <div style={style.dividerSubText}></div>
                        </div>
                        <UserChallenges userChallenges={timelineHistory} 
                                    onLaunchUserChallenge={onLaunchUserChallenge}
                                    formatDuration={formatDuration}
                                    typeToName={challengeTypeToName} />
                    </div> 
                )}

                {showSetGoals &&
                    <div style={style.setGoalsSpacer} />
                }
            </div> 
        }
        {Boolean(dimmerChallenge) &&
            <Dimmer style={{cursor: 'pointer'}} active onClick={()=>onLaunchChallenge(dimmerChallenge)}>
                <i className={(dimmerChallenge.category && dimmerChallenge.category.icon) ? dimmerChallenge.category.icon : 'icon-myHealthSphere-logo'} 
                       style={style.dimmerChallengeIcon}></i>
                <div style={style.dimmerChallengeDescription}>
                    {Utils.endlToBr(dimmerChallenge.dimmerMessage)}
                </div>
            </Dimmer>
        }
    </div>
)


export default translate(['challenges',
                          'misc',
                          'surveys',
                          'categories',
                          'translation'])(Today);



// WEBPACK FOOTER //
// ./src/modules/challenges/Today.js